import { useLayoutEffect } from "react";
import { useLocation } from "react-router-dom";

/**
 * React Router non resetta lo scroll al cambio di rotta: senza questo,
 * aprendo una pagina da una posizione scrollata la si vedrebbe "a metà".
 *
 * Il reset è ISTANTANEO: disabilitiamo temporaneamente scroll-behavior: smooth
 * (attivo globalmente per le ancore) così la nuova pagina parte subito dall'alto
 * invece di animare. Se l'URL contiene un'ancora (#sezione) scrolliamo lì.
 */
const ScrollToTop = () => {
  const { pathname, hash } = useLocation();

  useLayoutEffect(() => {
    if (hash) {
      const el = document.getElementById(hash.slice(1));
      if (el) {
        el.scrollIntoView();
        return;
      }
    }
    // behavior "instant" forza il salto immediato, ignorando lo
    // scroll-behavior: smooth applicato globalmente (che serve alle ancore).
    window.scrollTo({ top: 0, left: 0, behavior: "instant" as ScrollBehavior });
  }, [pathname, hash]);

  return null;
};

export default ScrollToTop;
